<template>
    <div class="load-on-scroll" v-on:scroll="handleScroll">
        <slot></slot>
    </div>
</template>

<script>
export default {
	methods: {
		handleScroll () {
			let e = event.target
			if (e.scrollTop + e.offsetHeight + 50 >= e.scrollHeight) {
				this.$emit('loadMore')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.load-on-scroll {
    overflow: auto;
    height: 100%;
    width: 100%;
}
</style>
